import React, { useState } from 'react'
import {
  Box,
  Center,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  Badge,
  Flex,
  IconButton,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Icon,
  RadioGroup,
  Radio,
} from '@chakra-ui/react'
import { FiCheck, FiX, FiLock } from 'react-icons/fi'

export function PedidosTable({ pedidos = [], isLoading, isFetching, isRefetching, error, onStatusPagamentoChange }) {
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null)
  const [novoStatus, setNovoStatus] = useState(false)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  const handleStatusChange = (pedido, pago) => {
    // Se o pedido já está marcado como pago (sim) e o usuário tenta mudar para não pago (não),
    // não permitimos a alteração
    if (pedido.pago && !pago) {
      return // Impede a alteração
    }

    setPedidoSelecionado(pedido)
    setNovoStatus(pago)
    onOpen()
  }

  const confirmarMudancaStatus = () => {
    if (pedidoSelecionado && onStatusPagamentoChange) {
      onStatusPagamentoChange(pedidoSelecionado.id, novoStatus)
    }
    onClose()
  }

  // Caso esteja carregando dados iniciais
  if (isLoading && !isFetching) {
    return (
      <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px" overflowX="auto">
        <Center p={10}>
          <Spinner size="xl" color="#378BBF" thickness="4px" />
        </Center>
      </Box>
    )
  }

  // Caso tenha ocorrido algum erro
  if (error) {
    return (
      <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px" overflowX="auto">
        <Center p={10}>
          <Text color="red.500" fontSize="12px">
            Erro ao carregar pedidos. Tente novamente mais tarde.
          </Text>
        </Center>
      </Box>
    )
  }

  // Caso não tenha encontrado pedidos
  if (pedidos.length === 0 && !isLoading && !isFetching) {
    return (
      <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px" overflowX="auto">
        <Center p={10}>
          <Text color="#313E44" fontSize="12px">
            Nenhum pedido encontrado.
          </Text>
        </Center>
      </Box>
    )
  }

  // Renderiza a tabela completa com indicador de carregamento quando necessário
  return (
    <>
      <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px" overflowX="auto" position="relative">
        {/* Indicador de carregamento no canto superior direito */}
        {(isFetching || isRefetching) && (
          <Flex position="absolute" top="10px" right="10px" zIndex={2} bg="blue.50" p={2} borderRadius="md" alignItems="center" shadow="md">
            <Spinner size="sm" color="#378BBF" mr={2} />
            <Text fontSize="xs" color="#378BBF" fontWeight="medium">
              {isRefetching ? 'Atualizando...' : 'Carregando...'}
            </Text>
          </Flex>
        )}

        <Table
          variant="striped"
          size="sm"
          colorScheme="blackAlpha"
          sx={{
            'tr:nth-of-type(odd) td': { bg: 'white !important' },
            'tr:nth-of-type(even) td': { bg: '#F4F5F5 !important' },
            'th, td': { textAlign: 'center !important' },
          }}
        >
          <Thead bg="#378BBF">
            <Tr>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Data
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Pedido
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Data Aprovação
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Cód. Do Produto
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Produto
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Cor
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Gravação
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Recebimento
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
                Status Pagamento
              </Th>
              <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center" width="160px">
                Pago
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {pedidos.map((pedido, index) => (
              <Tr key={index}>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.data}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.pedido}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.dataAprovacao}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.codigoProduto}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.produto}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.cor}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.gravacao}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.recebimento}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  {pedido.pago ? (
                    <Tooltip label="Pedido Pago" hasArrow placement="top">
                      <IconButton icon={<FiCheck />} colorScheme="green" size="sm" borderRadius="full" aria-label="Pedido pago" isRound />
                    </Tooltip>
                  ) : (
                    <Tooltip label="Pagamento Pendente" hasArrow placement="top">
                      <IconButton icon={<FiX />} colorScheme="red" size="sm" borderRadius="full" aria-label="Pagamento pendente" isRound />
                    </Tooltip>
                  )}
                </Td>
                <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                  <Box px={2} py={1} minWidth="160px">
                    <RadioGroup
                      value={pedido.pago ? 'sim' : 'nao'}
                      onChange={(value) => handleStatusChange(pedido, value === 'sim')}
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                      width="100%"
                    >
                      <Flex
                        alignItems="center"
                        bg={pedido.pago ? 'green.50' : 'transparent'}
                        p={2}
                        borderRadius="md"
                        width="48%"
                        justifyContent="center"
                      >
                        <Radio value="sim" colorScheme="green" size="md" borderWidth="2px" mr={1} isDisabled={false}>
                          <Text fontSize="14px" fontWeight={pedido.pago ? 'bold' : 'normal'} color="green.600">
                            Sim
                          </Text>
                        </Radio>
                      </Flex>
                      <Flex
                        alignItems="center"
                        bg={!pedido.pago ? 'red.50' : 'transparent'}
                        p={2}
                        borderRadius="md"
                        width="48%"
                        justifyContent="center"
                        position="relative"
                      >
                        <Radio
                          value="nao"
                          colorScheme="red"
                          size="md"
                          borderWidth="2px"
                          mr={1}
                          isDisabled={pedido.pago} // Desabilitar a opção "Não" quando o pedido estiver pago
                        >
                          <Text fontSize="14px" fontWeight={!pedido.pago ? 'bold' : 'normal'} color={pedido.pago ? 'gray.400' : 'red.600'}>
                            Não
                          </Text>
                        </Radio>
                        {pedido.pago && (
                          <Tooltip label="Não é possível alterar um pedido já pago" hasArrow placement="top">
                            <Icon
                              as={FiLock}
                              position="absolute"
                              right="-6px"
                              top="-6px"
                              color="gray.500"
                              bg="white"
                              borderRadius="full"
                              boxSize={4}
                            />
                          </Tooltip>
                        )}
                      </Flex>
                    </RadioGroup>
                  </Box>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {/* Dialog de confirmação de alteração de status */}
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirmar alteração de status
            </AlertDialogHeader>

            <AlertDialogBody>
              <Text mb={3}>
                Tem certeza que deseja marcar o pedido <strong>#{pedidoSelecionado?.pedido}</strong> como {novoStatus ? 'PAGO' : 'NÃO PAGO'}?
              </Text>

              {novoStatus ? (
                <Flex mt={2} alignItems="center" color="green.500">
                  <Icon as={FiCheck} mr={2} />
                  <Text>Esta ação registrará o recebimento do pagamento.</Text>
                </Flex>
              ) : (
                <Flex mt={2} alignItems="center" color="red.500">
                  <Icon as={FiX} mr={2} />
                  <Text>Esta ação marcará o pagamento como pendente.</Text>
                </Flex>
              )}

              {novoStatus && (
                <Flex mt={4} alignItems="center" color="orange.500" bg="orange.50" p={2} borderRadius="md">
                  <Icon as={FiLock} mr={2} />
                  <Text fontWeight="medium">Atenção: Após confirmar o pagamento, não será possível reverter esta ação.</Text>
                </Flex>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose} size="sm">
                Cancelar
              </Button>
              <Button
                colorScheme={novoStatus ? 'green' : 'red'}
                onClick={confirmarMudancaStatus}
                ml={3}
                size="sm"
                leftIcon={<Icon as={novoStatus ? FiCheck : FiX} />}
              >
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
